// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'Vuetify'
import 'Vuetify/dist/Vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary:   localStorage.getItem('tema_primario')   || '#1706FF',
        secondary: localStorage.getItem('tema_secundario') || '#0D47A1',
        accent:    localStorage.getItem('tema_acento')     || '#00BCD4',
        error:     '#F44336',
        success:   '#4CAF50',
        warning:   '#FF9800',
        info:      '#2196F3',
      },
      dark: {
        primary:   localStorage.getItem('tema_primario')   || '#1706FF',
        secondary: localStorage.getItem('tema_secundario') || '#0D47A1',
        accent:    localStorage.getItem('tema_acento')     || '#00BCD4',
      },
    },
    dark: localStorage.getItem('modo_oscuro') === '1',
  },
  icons: { iconfont: 'mdi' },
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  vuetify,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js